<script setup lang="ts">
import type { ComboboxItemEmits, ComboboxItemProps } from 'reka-ui'
import { ComboboxItem, useForwardPropsEmits } from 'reka-ui'
import { computed, type HTMLAttributes } from 'vue'

import { cn } from '../../../lib/utils'

const properties = defineProps<ComboboxItemProps & { class?: HTMLAttributes['class'] }>()
const emits = defineEmits<ComboboxItemEmits>()

const delegatedProperties = computed(() => {
  const { class: _, ...delegated } = properties

  return delegated
})

const forwarded = useForwardPropsEmits(delegatedProperties, emits)
</script>

<template>
  <ComboboxItem v-bind="forwarded" :class="cn('atabix-combobox-item', properties.class)">
    <slot />
  </ComboboxItem>
</template>

<style lang="scss">
.atabix-combobox-item {
  @apply relative;
  @apply flex;
  @apply cursor-default;
  @apply gap-2;
  @apply select-none;
  @apply items-center;
  @apply rounded-sm;
  @apply px-2;
  @apply py-1.5;
  @apply text-sm;
  @apply outline-none;

  &[data-highlighted] {
    @apply bg-tag-background;
    @apply text-tag-foreground;
  }

  &[data-disabled] {
    @apply pointer-events-none;
    @apply opacity-50;
  }
}
</style>
